/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const deleteContactBodyExpectedVersionExclusiveMin = 0;
export const deleteContactBodyExpectedVersionMax = 9007199254740991;

export const DeleteContactBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(deleteContactBodyExpectedVersionExclusiveMin)
    .max(deleteContactBodyExpectedVersionMax),
});

export type DeleteContactBody = zod.input<typeof DeleteContactBody>;
export type DeleteContactBodyOutput = zod.output<typeof DeleteContactBody>;
